module.exports = __webpack_public_path__ + "img/welcome.5d85c895.svg";